import forms from '../cms/forms.json';

const OPTION_LABELS = {
  'undergraduate-student': 'Undergraduate Student',
  'graduate-student': 'Graduate Student',
  alumni: 'Alumni',
  'family-member': 'Family Member',
  other: 'Other',
  parent: 'Parent',
  grandparent: 'Grandparent',
  sibling: 'Sibling',
  'not-sure': 'Unsure',
};

function getField(name) {
  const fields = forms['mailing-list']?.fields || [];
  return fields.find((f) => f.name === name) || {};
}

export function getMailingListFormDef() {
  return forms['mailing-list'] || {};
}

export function getMailingListField(name) {
  return getField(name);
}

export function getMailingListOptionLabel(value) {
  if (OPTION_LABELS[value]) return OPTION_LABELS[value];
  if (/^\d{4}$/.test(value)) return value;
  return value;
}
